const initialState = {
    distributionAreas: undefined,
    fetching: false,
    changing: false,
    fetched: false,
    error: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_DISTRIBUTION_AREAS_PENDING": {
            return {
                ...state,
                fetching: true
            };
        }
        case "FETCH_DISTRIBUTION_AREAS_FULFILLED": {
            return {
                ...state,
                fetching: false,
                distributionAreas: _.isEqual(state.distributionAreas, action.payload) ? state.distributionAreas : action.payload,
                fetched: true,
                error: null
            };
        }
        case "FETCH_DISTRIBUTION_AREAS_REJECTED": {
            return {
                ...state,
                fetching: false,
                error: action.payload
            };
        }

        case "EDIT_DISTRIBUTION_AREA_PENDING": {
            return {
                ...state,
                changing: true
            }
        }
        case "EDIT_DISTRIBUTION_AREA_FULFILLED": {
            const newDistAreas = [...state.distributionAreas];
            const foundDistAreaIndex = state.distributionAreas.findIndex(distArea => distArea.id === action.meta.id);
            newDistAreas[foundDistAreaIndex] = {...newDistAreas[foundDistAreaIndex], ...action.meta};

            return {
                ...state,
                distributionAreas: newDistAreas,
                changing: false,
                error: null
            }
        }
        case "EDIT_DISTRIBUTION_AREA_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            }
        }
    }

    return state;
}